module.exports = __webpack_public_path__ + "img/113.97fabefe.svg";